import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { logger } from "@/lib/logger";

/**
 * Modal for filing a dispute on an unlocked lead. Handles the reason input
 * and API call so the parent dashboard can stay presentation-focused.
 */
export default function DisputeModal({ job, onClose, onFiled }) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!reason.trim()) return toast.error("Add a reason");
    setSubmitting(true);
    try {
      await api.post("/disputes/by-job", { job_id: job.job_id, reason });
      toast.success("Dispute filed. Admin will review.");
      onFiled?.();
      onClose();
    } catch (err) {
      logger.error("[dispute] file failed", err);
      toast.error(err.response?.data?.detail || "Failed to file dispute");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="dispute-modal">
      <div className="absolute inset-0 bg-ink/50" onClick={onClose} />
      <div className="relative brut-card bg-white p-8 max-w-md w-full">
        <div className="overline mb-2">// Report bad lead</div>
        <h3 className="font-display font-bold uppercase text-2xl">{job.title}</h3>
        <p className="text-sm mt-3 text-muted-foreground">
          Tell us why this lead shouldn&apos;t have been charged. Admin will review and may refund credits.
        </p>
        <textarea
          className="brut-input min-h-[120px] mt-4"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="e.g. customer never responded / wrong number / spam"
          data-testid="dispute-reason"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="brut-btn" data-testid="dispute-cancel">Cancel</button>
          <button onClick={submit} disabled={submitting} className="brut-btn-primary" data-testid="dispute-submit">
            {submitting ? "Filing…" : "File dispute"}
          </button>
        </div>
      </div>
    </div>
  );
}
